/* eslint react/display-name: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';

import { STATUS } from '../../../../server/constants';
import { COLORS } from '_constants';

const UserMenu = ({
  status,
  active,
  onMenuClick,
  onRefreshUser,
  onResendVerification,
  userPanes,
}) => (
  <Menu attached='top' color={COLORS.USERS.MENU} inverted pointing borderless>
    <Menu.Menu position='left'>
      <Menu.Item name={userPanes.ACCOUNT} icon='user' active={active === userPanes.ACCOUNT} onClick={onMenuClick} />
      <Menu.Item name={userPanes.LICENSES} icon='database' active={active === userPanes.LICENSES} onClick={onMenuClick} />
      <Menu.Item name={userPanes.NOTES} icon='comment' active={active === userPanes.NOTES} onClick={onMenuClick} />
      <Menu.Item name={userPanes.ROLES} icon='cogs' active={active === userPanes.ROLES} onClick={onMenuClick} />
      <Menu.Item name={userPanes.SECURITY} icon='lock' active={active === userPanes.SECURITY} onClick={onMenuClick} />
    </Menu.Menu>

    <Menu.Menu position='right'>
      { status === STATUS.PENDING
        ? <Menu.Item icon='mail' onClick={onResendVerification} content='resend verification'/>
        : null
      }
      <Menu.Item icon='refresh' onClick={onRefreshUser} content='refresh'/>
    </Menu.Menu>
  </Menu>
);

UserMenu.propTypes = {
  status: PropTypes.string.isRequired,
  active: PropTypes.string.isRequired,
  onMenuClick: PropTypes.func.isRequired,
  onRefreshUser: PropTypes.func.isRequired,
  onResendVerification: PropTypes.func.isRequired,
  userPanes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default UserMenu;



// WEBPACK FOOTER //
// ./webAdmin/components/users/user/menu.js